import { AvvirRoutingEvent } from "type_aliases";

export type ToViewerFloorQuery = {
  photoLocationId?: number
};

export type ToViewerFloorEvent = AvvirRoutingEvent<typeof TO_VIEWER_FLOOR, {
  projectId: string
  floorId: string
  query?: ToViewerFloorQuery
}>

const toViewerFloor = (projectId: string, floorId: string, query?: ToViewerFloorQuery): ToViewerFloorEvent => ({
  type: TO_VIEWER_FLOOR,
  payload: {
    projectId,
    floorId,
    ...(query && { query })
  }
});

export const TO_VIEWER_FLOOR = "to_viewer_floor";

export default toViewerFloor;
